module.exports = __webpack_public_path__ + "img/logo-white.a02c83ee.png";